<template>
    <div class="text-container">
        <div class="title">소프트웨어 라이선스 및 서비스 계약</div>
        <div class="subtitle">【중요 공지】</div>
        <div class="text">
            [Guangzhou ixcam IoT Technology Co., Ltd.](이하 "ixcam")는 사용자에게 본 "소프트웨어 라이센스 및 서비스 계약"(이하 "본 계약")을 주의 깊게 읽고 완전히 이해하도록 요청합니다. 사용자는 본 계약의 조건, 특히 ix cam의 책임, 분쟁 해결 및 법적 적용을 면제하거나 제한하는 조건을 주의 깊게 읽고 완전히 이해해야 합니다. 책임을 배제하거나 제한하는 조항은 굵은 글씨로 표시되므로 주의 깊게 읽어야 합니다. 주의 깊게 읽고 본 계약에 동의할지 여부를 선택하십시오. (미성년자는 법적 보호자와 함께 읽어야 합니다.) 귀하가 이 소프트웨어를 다운로드, 설치, 사용하고 계정을 취득하고 로그인하는 것은 귀하가 본 계약을 수락하고 본 계약 조건에 구속된다는 동의로 간주됩니다.
        </div>
        <div class="text">
            ix cam은 본 계약을 개정할 권리가 있으며 업데이트된 계약 조건은 공식 웹사이트나 소프트웨어에 게시되며 게시일로부터 효력을 발생합니다. 사용자는 소프트웨어를 다시 다운로드하여 설치하거나 웹사이트에서 최신 버전의 계약 조건을 확인할 수 있습니다. ix cam이 본 약관을 수정한 후, 사용자가 수정된 약관에 동의하지 않는 경우, ix cam이 제공하는 "ix cam" 소프트웨어 및 서비스의 계속적인 사용을 즉시 중단하시기 바랍니다. ix cam이 제공하는 수정된 계약은 수락된 것으로 간주됩니다.
        </div>
        <div class="title">一、일반</div>
        <div class="text">
            1.1. 본 계약은 사용자의 ix cam "ix cam" 다운로드, 설치 및 사용에 관한 귀하(이하 "이용자"라고도 함)와 ix cam 및 그 운영 협력 단위(이하 "협력 단위") 간의 계약입니다. 시" 소프트웨어(이하 "광저우시"라 함). 본 소프트웨어") 및 회사의 관련 서비스 이용에 대한 동의입니다.
        </div>
        <div class="text">
            1.2. 소프트웨어 및 서비스는 스마트 단말기를 사용하는 사용자에게 스마트 제품 바인딩 및 작동과 같은 서비스를 제공하는 것을 포함하되 이에 국한되지 않는 모바일 스마트 단말기 장비에 설치하여 ix cam 가 제공하는 소프트웨어 및 서비스입니다.
        </div>
        <div class="text">
            1.3. 소프트웨어 및 서비스의 소유권 및 운영 권한은 ix cam이 소유합니다.
        </div>
        <div class="title">二、소프트웨어 허가 범위</div>
        <div class="text">
			2.1.ix cam은 사용자에게 이 소프트웨어에 대한 개인적이고 양도할 수 없고 재라이센스를 부여할 수 없는 비독점적 라이센스를 부여합니다.
            2.1. 소프트웨어는 사용자에게 개인적이고 양도할 수 없고 재허여 되지 않고 비독점적인 라이선스를 부여합니다.
        </div>
        <div class="text">
            2.2.사용자는 비상업적 목적으로 단일 모바일 단말 장치에 소프트웨어를 설치, 사용, 표시 및 실행할 수 있습니다. 그러나 사용자는 상업적 운영 목적으로 이 소프트웨어를 설치, 사용 또는 실행할 수 없으며 플러그인, 플러그인 또는 소프트웨어 및 관련 시스템에 액세스하기 위한 승인되지 않은 타사 도구/서비스. 소프트웨어 사전 설치 및 번들링 등 상업적 판매, 복제 및 배포가 필요한 경우 회사의 서면 승인 및 허가를 받아야 합니다.
        </div>
        <div class="text">
            2.3. 사용자는 셋톱박스, 게임 콘솔, TV, DVD 플레이어 등을 포함하되 이에 국한되지 않는 ix cam 가 명시적으로 승인하지 않은 다른 터미널 장치에 이 소프트웨어를 설치할 수 없습니다.
        </div>
        <div class="text">
            2.4.사용자는 소프트웨어 및 서비스를 사용할 목적으로 백업용으로만 소프트웨어 사본을 만들 수 있습니다. 백업 사본에는 원본 소프트웨어에 포함된 모든 저작권 정보가 포함되어야 합니다.
        </div>
        <div class="text">
            2.5.본 "계약"의 명시적 승인을 제외하고 BMORCHARDFLORIST.COM.MY는 사용자에게 다른 권한을 부여하지 않습니다.사용자가 다른 권한을 사용하는 경우 BMORCHARDFLORIST.COM.MY의 추가 서면 동의를 받아야 합니다.
        </div>
        <div class="title">三、소프트웨어 취득, 설치 및 업그레이드</div>
        <div class="text">
            3.1. 사용자는 지정된 웹사이트 또는 ix cam.의 지정된 방법에 따라 이 소프트웨어 제품을 다운로드하여 설치해야 합니다. 모바일 단말 장비가 사용자 데이터를 파괴하고 사용자 개인 정보를 얻을 수 있는 악성 프로그램에 감염되지 않도록 지정되지 않은 웹 사이트에서 이 소프트웨어를 다운로드하지 않도록 주의하십시오. 사용자가 회사가 승인하지 않은 제3자로부터 소프트웨어 또는 소프트웨어와 동일한 이름의 설치 프로그램을 취득한 경우, 회사는 소프트웨어의 정상적인 사용을 보장할 수 없으며 이로 인한 손실에 대해 책임을 지지 않습니다. 당신에게.
        </div>
        <div class="text">
            3.2. 사용자는 설치된 단말 장치와 일치하는 소프트웨어 버전을 선택해야 하며, 그렇지 않을 경우 소프트웨어와 장치 모델 간의 불일치로 인한 소프트웨어 문제, 장치 문제 또는 손상은 사용자가 부담합니다.
        </div>
        <div class="text">
            3.3. 사용자 경험을 개선하고 서비스 콘텐츠를 개선하기 위해 ix cam는 귀하에게 수시로 소프트웨어의 교체, 수정 및 업그레이드 버전을 제공할 권리와 교체 비용을 청구할 권리가 있습니다. , 수정 또는 업그레이드하지만 귀하의 동의하에 요금이 미리 청구됩니다. 이 소프트웨어는 기본적으로 사용자에 대한 "업그레이드 프롬프트" 기능을 활성화합니다. 사용자가 사용하는 소프트웨어 버전에 따라 ix cam 은 사용자가 이 기능을 활성화할지 여부를 선택할 수 있습니다. 새 버전의 소프트웨어가 출시된 후에는 이전 버전의 소프트웨어를 계속 사용할 수 있음을 보장하지 않습니다.
        </div>
        <div class="title">四、규범의 사용</div>
        <div class="text">
            4.1. 이용자는 법률 및 이 약관을 준수한다는 전제 하에 본 약관에 따라 소프트웨어 및 서비스를 이용할 수 있으며, 다음 행위를 하여서는 안됩니다.
        </div>
        <div class="text">
            •	4.1.1. 이 소프트웨어 및 기타 사본에 대한 모든 저작권 정보를 삭제하고 지적 재산권을 보호하기 위해 이 소프트웨어가 설정한 기술적 조치를 수정, 삭제 또는 회피합니다.
        </div>
        <div class="text">
            •	4.1.2. 디스어셈블, 디컴파일 또는 소프트웨어의 소스 코드를 얻으려는 시도와 같은 소프트웨어 리버스 엔지니어링;
        </div>
        <div class="text">
            •	4.1.3. 소프트웨어의 실행에 있어서 지시 및 데이터를 수정 또는 위조하거나, 소프트웨어의 기능 또는 작동 효과를 추가, 삭제, 변경하거나 상기 언급된 목적에 사용되는 소프트웨어 및 방법을 작동 또는 보급함으로써 상업적 목적인지 여부에 관계없이 이러한 행위에 관계없이 대중;
        </div>
        <div class="text">
            •	4.1.4. 이 소프트웨어를 사용하여 다음을 포함하되 이에 국한되지 않는 네트워크 보안을 위협하는 모든 행위를 수행합니다. 소프트웨어의 시스템 또는 네트워크를 허가 없이 수행하거나 네트워크 보안을 손상시키는 기타 행위를 수행하는 경우 소프트웨어 시스템 또는 웹사이트의 정상적인 작동을 방해하거나 파괴하려는 시도, 의도적으로 악성 프로그램 또는 바이러스를 유포하는 행위 및 정상적인 네트워크 정보 서비스를 방해 및 방해하는 기타 행위 ; TCP/IP 패킷 이름 또는 부분 이름 위조;
        </div>
        <div class="text">
            •	4.1.5. 사용자는 회사에서 개발, 승인 또는 인정하지 않은 타사 호환 소프트웨어 또는 시스템을 통해 소프트웨어 및 서비스에 로그인하거나 사용하거나 위의 도구를 생성, 게시 및 배포합니다.；
        </div>
        <div class="text">
            •	4.1.6. 사용자는 회사의 서면 동의 없이 허가 없이 소프트웨어 및 그 안의 정보를 사용, 대여, 대여, 복사, 수정, 링크, 재인쇄, 컴파일하는 행위를 포함하되 이에 국한되지 않습니다. 승인 없이 이 소프트웨어와 관련된 파생 제품, 저작물, 서비스, 플러그인, 플러그인, 호환성, 상호 연결 등을 개발, 게시, 게시, 미러 이미지 웹사이트 생성；
        </div>
        <div class="text">
            •	4.1.7. 이 소프트웨어를 사용하여 현지 법률 및 규정을 위반하는 콘텐츠를 게시, 전송, 배포 및 저장합니다；
        </div>
        <div class="text">
            •	4.1.8. 이 소프트웨어를 사용하여 타인의 지적 재산권, 영업 비밀 및 기타 법적 권리를 침해하는 콘텐츠를 게시, 전송, 배포 및 저장합니다；
        </div>
        <div class="text">
            •	4.1.9. 광고 정보 및 스팸을 일괄적으로 게시, 전송 및 보급하기 위해 이 소프트웨어를 사용합니다；
        </div>
        <div class="text">
            •	4.1.10. 이 소프트웨어 및 ix cam 에서 제공하는 기타 서비스를 불법적인 방식으로, 불법적인 목적으로 또는 본 계약의 사용과 일치하지 않는 방식으로 사용하는 행위；
        </div>
        <div class="text">
            4.2.정보 공개 사양
        </div>
        <div class="text">
            •	4.2.1．이 소프트웨어를 사용하여 귀하의 원래 의견, 데이터, 텍스트, 정보, 사용자 이름, 사진, 사진, 개인 정보, 오디오, 비디오 파일, 링크 및 기타 정보 콘텐츠를 표현할 수 있습니다. 업로드하거나 법적으로 승인된 정보의 지적 재산권을 소유하고 있는지, 소프트웨어 및 서비스 사용이 제3자의 합법적인 권리와 이익을 침해하지 않는지 확인해야 합니다.
        </div>
        <div class="text">
            •	4.2.2．이 소프트웨어의 사용은 현지 법률 및 규정의 적용을 받습니다。
        </div>
        <div class="text">
            4.2.3．이 소프트웨어를 사용할 때 이 소프트웨어를 사용하여 다음을 포함하되 이에 국한되지 않는 다음 행위를 해서는 안 됩니다：
        </div>
        <div class="text">
            4.2.3.1.현지 법률 및 규정을 위반하는 콘텐츠를 생산, 복제, 출판, 배포 및 저장합니다；
        </div>
        <div class="text">
            4.2.3.2.명예, 초상, 지적재산권, 영업비밀 등 타인의 법적 권리를 침해하는 콘텐츠를 게시, 전송, 유포 및 저장하는 행위；
        </div>
        <div class="text">
            4.2.3.3.사실을 날조하거나 진실을 은폐하여 다른 사람을 오도하거나 기만하는 행위；
        </div>
        <div class="text">
            4.2.3.4.광고성 정보 및 스팸의 게시, 전송 및 유포；
        </div>
        <div class="text">
            4.2.3.5.기타 현지 법규를 위반하는 행위를 하는 행위。
        </div>
        <div class="text">
            4.2.4. 귀하는 ix cam 의 허가 없이 이 소프트웨어에서 광고 게시 및 상품 판매와 같은 상업적 활동을 수행할 수 없습니다。
        </div>
        <div class="title">4.3.귀하는 다음 사항을 이해하고 동의합니다：</div>
        <div class="text">
            •	4.3.1. ix cam 는 사용자가 위에서 언급한 사용 사양을 위반한 것으로 의심되는지 여부를 판단하고 판단 결과에 따라 라이선스를 일시 중지 또는 종료하거나 본 계약에 따라 취할 수 있는 기타 제한 조치를 취합니다；
        </div>
        <div class="text">
            •	4.3.2. 사용자가 허가한 소프트웨어를 사용함에 있어 불법 또는 타인의 법적 권리를 침해하거나 이 약관을 위반한 것으로 의심되는 정보를 공개한 경우 회사는 이를 직접 삭제합니다；
        </div>
        <div class="text">
            •	4.3.3. 이용자가 위의 이용규칙을 위반하여 제3자에게 손해를 입힌 경우 귀하는 스스로 법적 책임을 져야 하며, 회사에 손실이나 비용 증가가 없도록 해야 합니다；
        </div>
        <div class="text">
            •	4.3.4．사용자가 관련 법령 또는 계약을 위반하여 회사에 손실을 입히거나 제3자에 의해 청구되거나 행정 기관에 의해 처벌되는 경우 사용자는 다음을 포함하여 발생한 손실 및/또는 비용을 회사에 배상해야 합니다. 합리적인 변호사 비용과 조사 및 증거 수집 비용。
        </div>
        <div class="title">五、서비스 위험 및 부인</div>
        <div class="text">
            5.1.이용자는 인터넷 접속 및 전기통신 부가서비스에 필요한 설비를 이용하기 위하여 자신의 이동단말장치를 갖추어야 하며, 인터넷 또는 제3자가 인터넷에 접속하기 위하여 개인 이동단말장치가 부과하는 통신료, 정보료 등을 부담하여야 합니다. 당사자(통신 또는 이동 통신 제공업체를 포함하되 이에 국한되지 않음) 관련 수수료. 통신 부가가치 서비스와 관련된 경우 통신 부가가치 서비스 제공업체에 관련 요금을 확인하는 것이 좋습니다。
        </div>
        <div class="text">
            5.2. ix cam  및 그 파트너는 통신 회선 장애, 기술 문제, 네트워크, 모바일 단말 장비 장애, 시스템 불안정 및 기타 불가항력적 사유와 같은 제3자로 인해 사용자가 입은 모든 손실에 대해 책임을 지지 않습니다。
        </div>
        <div class="text">
            5.3. 이 소프트웨어는 대부분의 인터넷 소프트웨어와 마찬가지로 사용자 이유, 네트워크 서비스 품질, 사회적 환경 및 기타 요인을 포함하되 이에 국한되지 않는 요인의 영향을 받으며 다른 사람의 사용자 정보 사용과 같은 다양한 보안 문제에 의해 방해받을 수 있습니다. 사용자 또는 방문한 다른 웹 사이트가 다운로드하여 설치한 기타 소프트웨어에는 사용자의 단말 장비 정보 및 데이터의 보안을 위협하고 이 소프트웨어의 정상적인 사용 등에 영향을 미치는 "트로이 목마"와 같은 바이러스가 포함되어 있습니다. 사용자는 정보 보안 및 사용자 데이터 보호에 대한 인식을 강화하고 비밀번호 보호 강화에 주의하여 손실 및 괴롭힘을 방지해야 합니다。
        </div>
        <div class="text">
            5.4. 사용자가 소프트웨어를 사용하거나 특정 서비스의 제공을 요청할 때 소프트웨어는 사용자의 사용 또는 액세스를 지원하기 위해 타사 시스템 또는 타사 소프트웨어를 호출할 수 있으며 사용 또는 액세스 결과는 제3자 시스템 또는 제3자 소프트웨어 지원을 통해 달성한 결과의 보안, 정확성, 유효성 및 기타 불확실한 위험과 그로 인해 발생하는 모든 분쟁 및 손해에 대해 ix cam은 가정하지 않습니다. 어떤 책임.
        </div>
        <div class="text">
            5.5. ix cam 은 사업 개발 및 조정에 있어 회사의 자율성을 보호하기 위해 ix cam 는 사용자에게 통지하지 않고 언제든지 서비스를 수정하거나 중단할 권리가 있으며 ix cam 는 서비스를 수정하거나 중단할 권리를 행사할 필요가 없음을 사용자에게 구체적으로 상기시킵니다. 사용자 또는 제3자에 대한 책임.
        </div>
        <div class="text">
            5.6. 우리는 법률 및 규정에 명시되어 있는 경우를 제외하고 관련 소프트웨어 및 관련 기술 및 정보가 안전하고 효과적이며 정확하고 신뢰할 수 있도록 최선을 다할 것이나 기존 기술에 의해 제한되며 사용자는 회사가 보증할 수 없음을 이해합니다. 이..
        </div>
        <div class="text">
            5.7. 다음 상황으로 인해 발생하거나 이와 관련된 이익 손실, 데이터 손실, 비즈니스 중단 손해 또는 기타 상업적 손해를 포함하되 이에 국한되지 않는 개인 상해 또는 우발적, 간접적 경제적 손해 손실은 사용자가 부담합니다. :
        </div>
        <div class="text">
            •	5.7.1.라이선스가 부여된 소프트웨어의 사용 또는 사용 실패;
        </div>
        <div class="text">
            •	5.7.2.제3자의 소프트웨어 무단 사용 또는 사용자 데이터 변경；
        </div>
        <div class="text">
            •	5.7.3.소프트웨어를 사용하는 사용자의 행동으로 인해 발생하는 비용 및 손실;
        </div>
        <div class="text">
            •	5.7.4.소프트웨어에 대한 사용자의 오해;
        </div>
        <div class="text">
            •	5.7.5.기타 회사의 귀책사유가 아닌 소프트웨어 관련 손실。
        </div>
        <div class="text">
            5.8. 귀하의 오도 또는 기만으로 인해 소프트웨어를 통한 사용자와 소프트웨어의 다른 사용자 간의 행동으로 인해 발생했거나 발생할 수 있는 개인 또는 경제적 피해 또는 손실은 법률에 따라 결함이 있는 당사자가 부담해야 합니다.
        </div>
        <div class="title">六、지적 재산권 진술</div>
        <div class="text">
            6.1. 이 소프트웨어의 지적 재산권은 ix cam에 있습니다. 이 소프트웨어의 모든 저작권, 상표, 특허, 영업 비밀 및 기타 지적 재산권과 이 소프트웨어와 관련된 모든 정보 콘텐츠(텍스트, 그림, 오디오, 비디오, 그래픽, 인터페이스 디자인, 레이아웃 프레임워크, 관련 데이터(또는 전자 문서 등)는 현지 법률 및 규정 및 해당 국제 조약에 의해 보호되며 당사는 위의 지적 재산권을 향유합니다.
        </div>
        <div class="text">
            6.2 ix cam  그룹의 서면 동의 없이 사용자는 상업적 또는 비상업적 목적으로 위의 지적 재산권을 스스로 또는 라이선스에 의해 제3자에게 구현, 활용 또는 양도할 수 없습니다. 위의 행위.
        </div>
        <div class="title">七、계약 변경</div>
        <div class="text">
            7.1. ix cam 는 필요에 따라 이 약관을 수정할 수 있는 권리가 있으며, 약관이 변경된 경우에는 변경된 약관을 해당 페이지에 공지합니다. 변경된 내용에 동의하지 않을 경우 이용자는 적극적으로 서비스를 해지하여야 합니다. 이용자가 서비스를 계속 이용할 경우 약관의 변경 사항에 동의하는 것으로 간주됩니다.
        </div>
        <div class="text">
            7.2.  ix cam 와 협력사는 필요에 따라 제공되는 과금 서비스, 과금 기준, 과금 방법, 서비스 요금 및 서비스 조건을 수정하거나 변경할 권리가 있습니다. ix cam 은 서비스를 제공할 때 현재 또는 미래에 일부 서비스의 사용자에게 특정 요금을 부과하기 시작할 수 있으며, 사용자가 이러한 요금 지불을 거부할 경우 요금이 시작된 후 관련 서비스를 계속 사용할 수 없습니다. ix cam 및 협력 회사는 이메일 또는 기타 수단으로 관련 수정 또는 변경 사항을 사용자에게 알리기 위해 최선을 다할 것입니다.
        </div>
        <div class="title">八、준거법 및 분쟁해결</div>
        <div class="text">
            8.1. 본 계약 조건의 유효성과 해석은 중화인민공화국 본토의 법률을 따릅니다. 관련 법률 조항이 없는 경우 국제 비즈니스 관행 및/또는 비즈니스 관행을 참조합니다.
        </div>
        <div class="text">
            8.2.  본 계약이 체결된 장소는 광저우시 남사구입니다。
        </div>
        <div class="text">
            8.3． 이용자와 ix cam은 본 서비스와 관련하여 발생하는 모든 분쟁은 협상을 통해 해결되어야 한다는 점에 동의합니다. 협상이 실패할 경우, 양 당사자는 본 계약이 체결된 곳을 관할하는 법원에 소송을 제기할 수 있습니다.
        </div>
        <div class="title">九、기타</div>
        <div class="text">
            9.1. 이용자가 소프트웨어의 특정 서비스를 이용함에 있어 서비스에 별도의 약정 및 관련 업무규칙 등(이하 "별도약관"이라 함)이 있을 수 있으며, 서비스를 이용하시기 전에 본 서비스를 이용하시기 전에 아래의 내용을 반드시 읽고 동의하신 후 이용하시기 바랍니다. 관련 별도 계약.
        </div>
        <div class="text">
            9.2.본 약관의 시행일은 20022년 3월 7일입니다.
        </div>
        <div class="text">
            9.3. 본 약관의 모든 조항의 명칭은 가독성을 위한 것으로, 그 자체로는 실질적인 의미가 없으며, 본 약관의 의미 해석의 근거로 사용할 수 없습니다.
        </div>
        <div class="text">
            9.4.어떤 이유로든 이 계약의 조건은 부분적으로 유효하지 않거나 시행할 수 없으며 나머지 조건은 여전히 유효하며 양 당사자를 구속합니다.
        </div>
        <div class="text">
            ix cam
        </div>
    </div>
</template>

<script type="text/javascript">
    export default {
        data() {
            return {

            }
        },
        methods: {

        }
    }
</script>

<style lang="less" scoped>
    .text-container {
        padding: 0 50px;
        .title {
            font-size: 30px;
            margin: 15px 0;
            font-weight: 900;
        }
        .subtitle {
            font-size: 25px;
            margin: 10px 0;
            font-weight: 600;
        }
    }
</style>